export default __webpack_public_path__ + "static/linotte-regular-webfont-26558bd6068e2732c2abc635aabac8c5.woff";